import {
  AwardError,
  FarePriceErrorType,
  HttpStatusCode,
  OneTimePasswordErrorType,
  PassengerErrorMap,
  PassengerFieldError,
} from 'shared';

export type ApiErrorData =
  | { type: Exclude<AwardError, AwardError.PASSENGER_FIELD_ERRORS> }
  | {
      type: AwardError.PASSENGER_FIELD_ERRORS;
      fieldErrors: Record<string, PassengerFieldError[]>;
    };

export class ApiError extends Error {
  status: HttpStatusCode;
  data: ApiErrorData;

  constructor(message: string, status: HttpStatusCode, data: ApiErrorData) {
    super(message);
    this.status = status;
    this.data = data;
    this.name = this.constructor.name;
  }
}

export class OneTimePasswordError extends Error {
  type: OneTimePasswordErrorType;

  constructor(type: OneTimePasswordErrorType) {
    super('One time password error');
    this.type = type;
    this.name = this.constructor.name;
  }
}

export class FarePriceError extends Error {
  type: FarePriceErrorType;

  constructor(type: FarePriceErrorType) {
    super('Price validation failed');
    this.type = type;
    this.name = this.constructor.name;
  }
}

export class NoAuthCookieError extends Error {
  constructor() {
    super('User is not authenticated');
    this.name = this.constructor.name;
  }
}

export class BookingFailedRefundedError extends Error {
  constructor() {
    super('Booking Failed. Refunded');
    this.name = this.constructor.name;
  }
}

export class BookingFailedNotRefundedError extends Error {
  constructor() {
    super('Booking Failed. Not Refunded');
    this.name = this.constructor.name;
  }
}

export class PaymentSessionExpiredError extends Error {
  constructor() {
    super('Payment token expired');
    this.name = this.constructor.name;
  }
}

export class BookingTimeoutError extends Error {
  constructor() {
    super('Booking has been in PENDING state for more than 40 seconds');
    this.name = this.constructor.name;
  }
}

export class PassengersFieldError extends Error {
  passsengerFieldErrors: PassengerErrorMap;

  constructor(passsengerFieldErrors: PassengerErrorMap) {
    super('Passenger field errors');
    this.passsengerFieldErrors = passsengerFieldErrors;
    this.name = this.constructor.name;
  }
}
